<template>
  <el-dialog
    title="Broken Asset"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="closable"
    @closed="$emit('destroy')"
  >
    <AssetBrokenForm
      v-loading="isProcessing"
      :asset="asset"
    />

    <template #footer>
      <el-button
        :disabled="!closable"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        :disabled="!closable"
        @click.native="updateAsset"
      >
        Confirm
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import AssetBrokenForm from '@/components/Application/Manage/Assets/Asset/BrokenForm'

export default {
  components: {
    AssetBrokenForm
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isVisible: true,
      isProcessing: false
    }
  },
  computed: {
    closable () {
      return !this.isProcessing
    }
  },
  methods: {
    async updateAsset () {
      this.isProcessing = true

      try {
        await this.asset.save()
        this.$message.success(`Updated Asset ${this.asset.serial}`)
      } finally {
        this.isVisible = false
      }
    }
  }
}
</script>
